export default __webpack_public_path__ + "static/media/24.cbcb0cf2.png";